import { render, staticRenderFns } from "./ExpirationInput.vue?vue&type=template&id=645c8e61&scoped=true&"
import script from "./ExpirationInput.vue?vue&type=script&lang=ts&"
export * from "./ExpirationInput.vue?vue&type=script&lang=ts&"
import style0 from "./ExpirationInput.vue?vue&type=style&index=0&id=645c8e61&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645c8e61",
  null
  
)

export default component.exports